import { Button } from "component/ui/Button";
import { GenericBtn } from "pages/finance/v2/FinanceRequest";
import React from "react";
import { Modal } from "react-bootstrap";

const DeleteFinanceModal = ({ reason, setReason, show, onClose, isLoading, onSubmit, isDeleteFinance }) => {
    return (
        <Modal
            show={show}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="border-0 z-[9999]"
            onHide={onClose}
        >
            <Modal.Body
                style={{
                    borderRadius: "16px",
                    padding: "0px",
                    border: "none",
                }}
                className="bg-white rounded-md"
            >
                <div className="w-full gap-4 px-4 py-4 ">
                    <div className="flex items-center justify-between">
                        <h5 className="text-xl font-semibold text-gray-90">
                            {!isDeleteFinance ? "Cancel request" : "Delete Finance"}
                        </h5>

                        <span
                            className="cursor-pointer material-icons"
                            style={{ color: "#667085" }}
                            onClick={onClose}
                        >
                            close
                        </span>
                    </div>
                    {isDeleteFinance ? (
                        <p className="text-base font-normal text-gray-50">
                            {!isDeleteFinance
                                ? "Request payment for active invoices, orders and transactions"
                                : "Are you sure you want to delete this draft?"}
                        </p>
                    ) : null}
                    {!isDeleteFinance && (
                        <div className="mt-3">
                            <label className="mb-1 text-sm text-gray-70">
                                Reason for cancelling request
                            </label>
                            <textarea
                                name=""
                                style={{
                                    border: "none",
                                    width: "100%",
                                    borderRadius: "8px",
                                    padding: "8px 16px",
                                    outline: "none",
                                    background: "#ECEFF3",
                                }}
                                id=""
                                cols="10"
                                rows="5"
                                value={reason}
                                placeholder="Why are you cancelling this request"
                                onChange={(e) => setReason(e.target.value)}
                            />
                        </div>
                    )}
                </div>

                <div
                    className="flex items-center justify-end p-3 gap-x-5"
                    style={{
                        borderTop: "1px solid #E7E9FB",
                    }}
                >
                    {!isDeleteFinance ? (
                        <GenericBtn
                            disabled={isLoading || reason.length < 2}
                            onClick={() => onSubmit('payment')}
                            className="px-4 py-0"
                            text="Cancel request"
                            size="sm"
                        />
                    ) : (
                        <>
                            <Button
                                variant="outline"
                                className={"h-[48px] px-4 text-sm"}
                                onClick={onClose}
                            >
                                Cancel
                            </Button>
                            <GenericBtn
                                disabled={isLoading}
                                onClick={onSubmit}
                                className="px-4 py-0"
                                text="Yes - delete"
                                size="sm"
                            />
                        </>
                    )}
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default DeleteFinanceModal;
